import fetch from 'isomorphic-fetch'

const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const createRequestBody = (request) => {
  return {
    method: request.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.body)
  }
}

const mapObjectToQueryString = (params) =>
  Object.keys(params)
    .filter((key) => {
      return params[key] !== undefined && params[key] !== null && params[key] !== ''
    })
    .map((key) => {
      if (Array.isArray(params[key])) {
        return params[key]
          .map((param) => {
            return `${encodeURIComponent(key)}[]=${encodeURIComponent(param)}`
          })
          .join('&')
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    })
    .join('&')

const getResourceInfo = async (resourceId) => {
  const requestUrl = `${API_URL_AVT}/nebula/resources/v2/${resourceId}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getResourceAssignedTasks = async (resourceId, { limit = 10, offset = 0 }) => {
  const queryString = mapObjectToQueryString({ limit, offset })
  const requestUrl = `${API_URL_AVT}/nebula/resources/${resourceId}/assigned-tasks?${queryString}`

  let requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getResourceHistoricTasks = async (resourceId, { limit = 10, offset = 0, from, to, states }) => {
  const queryString = mapObjectToQueryString({ limit, offset, from, to, states })
  const requestUrl = `${API_URL_AVT}/nebula/resources/${resourceId}/historic?${queryString}`

  let requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getFleetsByResource = async (resourceId) => {
  const requestUrl = `${API_URL_AVT}/nebula/capacity/${resourceId}/fleetPermissions`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getQuotasByResource = async (resourceId, { from, to }) => {
  const queryString = mapObjectToQueryString({ from, to })
  const requestUrl = `${API_URL_AVT}/nebula/capacity/${resourceId}/quotas-by-resource?${queryString}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const createQuotasByResource = async (fleetId, resourceId, quotas) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/quotas/create-by-resource`

  const requestBody = await createRequestBody({
    method: 'POST',
    body: { fleetId, resourceId, quotas }
  })
  return fetch(requestUrl, requestBody)
}

const deleteQuotasByResource = async (fleetId, resourceId, quotas) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/quotas/delete-by-resource`

  const requestBody = await createRequestBody({
    method: 'PUT',
    body: { fleetId, resourceId, quotas }
  })
  return fetch(requestUrl, requestBody)
}

const updateQuotasByResource = async (resourceId, { from, to, quotas }) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/${resourceId}/update-quotas-by-resource`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: { from, to, quotas }
  })
  return fetch(requestUrl, requestBody)
}

export {
  getResourceInfo,
  getResourceAssignedTasks,
  getQuotasByResource,
  updateQuotasByResource,
  createQuotasByResource,
  deleteQuotasByResource,
  getFleetsByResource,
  getResourceHistoricTasks
}
